import styled from 'styled-components';

export const DataPointSection = styled.div`
    padding-bottom: 20px;
`;

export const TrainingRegistrationManagementSection = styled.div`
    > .loading-mask {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 100px 0;
    }
`;

export const TrainingRegistrationSectionHeader = styled.div`
    padding-bottom: 20px;
    text-align: justify;

    owc-typography {
        color: var(--one-color-gray-600);
    }
`;

export const TrainingRegistrationMappingSection = styled.div`
    text-align: justify;

    owc-typography {
        color: var(--one-color-gray-600);
    }

    > div:first-child {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 5px 60px;
    }
`;

export const TrainingRegistrationSectionContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px 50px 5px 0;
`;

export const TrainingRegistrationSectionContentHeader = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 20px;
    padding-bottom: 16px;

    .mandatory-fields {
        /* width: 40%; */

        /* WORKAROUND */
        width: 60%;
    }

    .actions {
        width: 20%;
    }
`;
